<script>
  let { status } = $props();

  // Maps both post and per-target statuses to a stamp-pad ink. The .ink-stamp
  // border follows currentColor, so a text utility tints the whole stamp.
  const styles = {
    draft:         'text-secondary-600',
    scheduled:     'text-accent-700',
    publishing:    'text-amber-700',
    pending:       'text-secondary-600',
    published:     'text-emerald-800',
    failed:        'text-red-800',
    active:        'text-emerald-800',
    inactive:      'text-secondary-600',
    error:         'text-red-800',
    assigned:      'text-accent-700',
    synced:        'text-emerald-800',
    needs_resync:  'text-amber-700',
    cancelled:     'text-secondary-600',
  };

  let cls = $derived(styles[status] || styles.draft);
</script>

<span class="ink-stamp text-xs {cls}">
  {status}
</span>
